module.exports = __webpack_public_path__ + "img/logo.7381559c.svg";